export default {
    cuttingJobs: [], 
    cuttingJobsLoading: false,
    channels: [],
    statuses: [],
}
